import request from '@api/request';
import {
  GetProfileServicePayload,
  GetProfileServicePlacePayload,
  GetProfileServicePlaceResponse,
  GetProfileServiceResponse,
  GetUserInsurancePayload,
  GetUserInsuranceResponse,
  GetUserServiceByDoctorIdPayload,
  GetUserServiceByDoctorIdResponse,
} from '@models/profile';
import { BuildHeaders } from '@utilities/build-headers';

export const GetProfileService = async (
  payload: GetProfileServicePayload,
): Promise<GetProfileServiceResponse> => {
  return await request.get(
    `/ProfileService/${payload?.id}/${payload?.profileType}`,
  );
};

export const GetUserInsurance = async (
  payload: GetUserInsurancePayload,
): Promise<GetUserInsuranceResponse> => {
  const { id, ...rest } = payload;
  const headers = BuildHeaders(rest);

  return await request.get(`/UserInsurance/get-by-profile/${id}`, undefined, {
    headers: headers,
  });
};

export const GetProfileServicePlace = async (
  payload: GetProfileServicePlacePayload,
): Promise<GetProfileServicePlaceResponse> => {
  const { id, ...rest } = payload;

  const headers = BuildHeaders(rest);
  return await request.get(`/ProfileService/Place/${id}`, undefined, {
    headers: headers,
  });
};

export const GetUserInsuranceByDoctorId = async (
  payload: GetUserInsurancePayload,
): Promise<GetUserInsuranceResponse> => {
  const { id, ...rest } = payload;
  const headers = BuildHeaders(rest);

  return await request.get(`/UserInsurance/get-by-owner/${id}`, undefined, {
    headers: headers,
  });
};

export const GetUserServiceByDoctorId = async (
  payload: GetUserServiceByDoctorIdPayload,
): Promise<GetUserServiceByDoctorIdResponse> => {
  const { id, ...rest } = payload;
  const headers = BuildHeaders(rest);

  return await request.get(`UserService/get-by-owner/${id}`, undefined, {
    headers: headers,
  });
};
